import styled from 'styled-components';
import { Subtitle2Styles } from '../typography';
import { getColor, getColorShade, getSizeBy } from '../../../src/styled/utils';
import { Tooltip } from '../tooltip';
export const StyledFormHelperText = styled.div.attrs({
    role: 'alert'
}) `
  ${Subtitle2Styles}
  display: grid;
  grid-column-gap: ${getSizeBy(2)};
  grid-template-columns: max-content 1fr;
  align-items: start;
  margin-top: ${({ children, theme }) => (children ? getSizeBy(1.5)({ theme }) : '0')};
  padding-bottom: ${({ children, fixedPadding, theme }) => !children && fixedPadding ? getSizeBy(5.5)({ theme }) : 0};
  color: ${({ $msgType }) => {
    switch ($msgType) {
        case 'success': {
            return getColor('success');
        }
        case 'error': {
            return getColor('danger');
        }
        case 'warning': {
            return getColor('warning');
        }
        default: {
            return getColorShade('onSurface', 'mediumEmphasis');
        }
    }
}};

  &:empty {
    display: none;
  }

  ${({ fixedPadding }) => fixedPadding
    ? `> span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        word-break: normal;
      }`
    : `> span {
        word-break: break-word;
      }
    `}
`;
export const StyledTooltip = styled(Tooltip) `
  & div {
    max-width: ${getSizeBy(54)};
  }
`;
